<template>
  <div class="page-content bind-card">
    <div class="page-tit tit">
      <div :class="['item', bindCardStatus1 ? 'clr-g' : 'clr-b']">
        <div class="name">绑卡1</div>
        <div class="sts">{{ bindCardStatus1 ? "已完成" : "未完成" }}</div>
      </div>
      <div class="arrow">
        <svg viewBox="0 0 1035 1024" width="16" height="16">
          <path
            d="M530.850448 573.163313c32.005172-31.883636 32.111192-87.434343-0.069818-119.489939C399.437114 322.845737 268.507336 191.603071 137.436629 60.506505c-12.621576-12.625455-27.585939-20.686869-45.26804-23.540364-3.529697-0.570182-7.085253-0.999434-10.630465-1.499798-1.025293 0-2.055758 0-3.081051 0-4.035232 0.575354-8.111838 0.943838-12.091475 1.757091-33.298101 6.818909-54.838303 26.616242-63.959919 59.278222-3.201293 11.479919-2.806949 24.85398-1.135192 35.701657 1.751919 11.344162 7.11499 21.818182 14.479515 30.904889 3.444364 4.252444 7.050343 8.418263 10.918788 12.291879 111.045818 111.127273 222.142061 222.222222 333.247354 333.293899 1.444202 1.444202 3.227152 2.554828 5.187232 4.080485-2.121697 2.222545-3.475394 3.696485-4.879515 5.100606C252.653437 625.450667 145.164468 733.112889 37.416912 840.506182c-15.829333 15.773737-33.541172 31.162182-36.146424 54.273293-1.233455 10.908444-1.859232 22.111677 0 32.929616 0.919273 5.363071 3.262061 10.423596 5.494949 15.358707 23.655434 52.318384 89.514667 64.241778 130.66602 23.186101C268.668953 835.315071 399.501761 703.987071 530.850448 573.163313L530.850448 573.163313zM78.451902 35.466343l-12.091475 1.757091C70.345235 36.410182 74.421841 36.041697 78.451902 35.466343L78.451902 35.466343zM551.467498 36.441212c-38.000485 2.858667-70.434909 37.034667-71.651556 75.106263-0.79903 24.979394 8.131232 45.650747 25.691798 63.197091 111.383273 111.252687 222.661818 222.615273 334.015354 333.893818 1.534707 1.534707 3.686141 2.448808 6.595232 4.327434-3.35903 2.667313-5.116121 3.803798-6.565495 5.253172-68.050747 68.000323-136.075636 136.035556-204.100525 204.065616C591.916791 765.814949 548.391619 809.360808 504.845761 852.880808c-19.449535 19.439192-28.328081 42.706747-24.045899 70.054788 4.829091 30.919111 22.440081 52.516202 51.712 63.010909 29.450343 10.550303 56.692364 4.803232 80.49002-15.848727 1.944566-1.682101 3.798626-3.470222 5.616485-5.288081 130.121697-130.111354 259.955071-260.509737 390.546101-390.141414 33.272242-33.035636 33.454545-88.934141 1.206303-121.050505C879.016912 322.804364 748.093599 191.557818 617.028064 60.456081c-12.626747-12.626747-27.611798-20.655838-45.288727-23.505455-3.534869-0.570182-7.090424-0.994263-10.635636-1.484283-1.030465 0-2.055758 0-3.086222 0.005172C555.835013 35.799919 553.659013 36.274424 551.467498 36.441212L551.467498 36.441212zM551.467498 36.441212"
            fill="#666"
          ></path>
        </svg>
      </div>
      <div :class="['item', bindCardStatus2 ? 'clr-g' : '']">
        <div class="name">绑卡2</div>
        <div class="sts">{{ bindCardStatus2 ? "已完成" : "未完成" }}</div>
      </div>
    </div>
    <div class="page-form content">
      <Form
        :ref="`bind-card`"
        :defaultForm.sync="form"
        :fields="fields"
        :defaultText.sync="fieldTexts"
      >
        <van-field
          slot="field-custom-smsCode"
          v-model.trim="form.smsCode"
          label="验证码"
          placeholder="请输入验证码"
          input-align="right"
        >
          <template #button>
            <div
              :class="['send-btn', sending ? 'sending' : '']"
              @click="getCode"
            >
              {{ sending ? `${second}s` : "获取验证码" }}
            </div>
          </template>
        </van-field>
      </Form>
    </div>

    <div class="page-btn btns">
      <van-button type="info" size="small" @click="submitFn">提交</van-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  bindCardStatus,
  sendBindCardSms,
  bindCardSubmit,
  bankEnums
} from "@/api/apply";
export default {
  components: {
    Form: () => import("@/components/Form/Index")
  },
  data() {
    return {
      required: [
        {
          required: true
        }
      ],
      bizNo: "",
      bindCardStatus1: false,
      bindCardStatus2: false,
      requestData: {},
      form: {},
      bankEnums: [],
      sending: false, // loading
      second: 60,
      itv: null, // 定时器
      fieldTexts: {}
    };
  },
  computed: {
    fields() {
      return [
        {
          type: "text",
          label: "账户名",
          disabled: true,
          key: "cusName"
        },
        {
          type: "text",
          label: "银行卡号",
          disabled: true,
          key: "bankCardNo"
        },
        {
          type: "select",
          label: "开户银行",
          required: true,
          key: "bankCode",
          enums: this.bankEnums,
          useSearch: true,
          change: (v) => {
            this.$set(this.form, "bankName", v?.text);
          }
        },
        {
          type: "region",
          label: "开户行所在地",
          required: true,
          keys: ["cardProv", "cardCity"],
          key: "acceptLocation"
        },
        {
          type: "text",
          label: "开户行支行",
          required: true,
          key: "accoBrunName"
        },
        {
          type: "number",
          label: "银行预留手机",
          required: true,
          key: "bankMobile",
          validator: (v) => {
            const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
            if (v && !reg.test(v)) throw "请输入正确的手机号";
            else return true;
          }
        },
        {
          type: "custom",
          label: "验证码",
          placeholder: "请输入验证码",
          required: true,
          key: "smsCode"
        }
      ];
    }
  },
  created() {
    this.init();
    this.getBankEnums();
  },
  methods: {
    ...mapGetters(["getUserOrderInfo"]),
    async getBankEnums() {
      try {
        const { data } = await bankEnums();
        this.bankEnums = (data || []).map((e) => {
          return {
            text: e.bankName,
            value: e.bankCode
          };
        });
      } catch (error) {
        this.$errMsg(error);
      }
    },
    init() {
      const data = this.getUserOrderInfo();
      this.bizNo = data.bizNo || "";
      this.getStatus();
    },
    getSmsSendType() {
      const typeKey = `resend_type_${this.$route.name}_${this.bizNo}`;
      let resendType = window.localStorage.getItem(typeKey);
      if (resendType) {
        return resendType;
      } else {
        this.setSmsSendType(1);
        return 1;
      }
    },
    setSmsSendType(v) {
      const typeKey = `resend_type_${this.$route.name}_${this.bizNo}`;
      window.localStorage.setItem(typeKey, v);
    },
    async getStatus() {
      try {
        this.$toast.loading({
          forbidClick: true,
          duration: 0
        });
        const { data } = await bindCardStatus(this.bizNo);
        if (data?.bindCardStatus1) this.$router.push("/bindcard-2");
        this.bindCardStatus1 = data?.bindCardStatus1 || false;
        this.bindCardStatus2 = data?.bindCardStatus2 || false;
        const { cusName, bankCardNo } = data || {};
        this.$set(this.form, "cusName", cusName);
        this.$set(this.form, "bankCardNo", bankCardNo);
        this.$toast.clear();
      } catch (error) {
        this.$errMsg(error);
      }
    },
    async getCode() {
      if (this.sending) return;
      const mobilePass = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(
        this.form.bankMobile
      );
      if (!mobilePass) {
        this.$toast.fail("请输入正确的手机号");
        return;
      }
      try {
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          duration: 0
        });
        const params = {
          bizNo: this.bizNo,
          resendType: this.getSmsSendType(),
          ...this.form
        };
        const { data } = await sendBindCardSms(params);
        this.setSmsSendType(2);
        this.requestData = data || {};

        setTimeout(() => {
          this.$toast.success("验证码已发送，请注意查收！");
        }, 100);
        this.sending = true;
        this.itv = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            this.second = 60;
            this.sending = false;
            clearInterval(this.itv);
          }
        }, 1000);
        return Promise.resolve(true);
      } catch (error) {
        this.sending = false;

        this.$errMsg(error);
        return Promise.reject(error);
      }
    },
    async submitFn() {
      try {
        const infodom = this.$refs["bind-card"];
        await infodom.validate();
        const params = {
          bizNo: this.bizNo,
          smsCode: this.form.smsCode,
          ...this.requestData
        };
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          duration: 0
        });
        await bindCardSubmit(params);
        this.setSmsSendType(1);
        this.$toast.clear();
        this.$router.push("/bindcard-2");
      } catch (error) {
        this.$errMsg(error);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./input-style.scss";
.bind-card {
  .tit {
    display: flex;
    height: 96px;
    border-bottom: 1px solid #eee;
    & > * {
      display: flex;
      align-items: center;
      justify-content: center;
      &.item {
        flex-direction: column;
      }
    }
    .arrow {
      flex: 1;
    }
    .item {
      color: #666;
      width: 45%;
      font-size: 32px;
      font-weight: bold;
      .sts {
        font-size: 28px;
        font-weight: normal;
      }
    }
  }
  .btns {
    .van-button {
      width: 45%;
      height: 100%;
    }
  }
}
</style>
